import styled, { css } from 'styled-components'

export const Wrapper = styled.nav`
  ${({ theme }) => css`
    width: 210px;
    padding: 16px 0;
    border-radius: 16px;
    background: ${theme.colors.black};
    color: ${theme.colors.white};
    position: sticky;
    top: 96px;
    margin-bottom: 32px;
  `}
`

export const NavList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const NavItem = styled.li`
  ${({ theme }) => css`
    letter-spacing: 1px;
    text-transform: uppercase;
    color: ${theme.colors.grey};
    padding-left: 32px;
    margin: 16px 0;
    position: relative;
    transition: 0.3s;

    &:hover {
      color: ${theme.colors.white};
    }

    a {
      display: block;
      cursor: pointer;

      &.active {
        color: ${theme.colors.white};

        &:after {
          content: '';
          display: block;
          height: 25px;
          width: 4px;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
          background: ${theme.colors.yellow};
        }
      }
    }
  `}
`
